import React from 'react';

import footerStyles from './AlmeFooter.styles';
import AlmeInput from '../AlmeInput/AlmeInput';
import AlmePoweredByLink from '../AlmePoweredByLink/AlmePoweredByLink';

import { Container } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeFooterConfig } from './AlmeFooterConfig';
import AlmeDisclaimer from "../AlmeDisclaimer/AlmeDisclaimer";

interface AlmeFooterProps extends WithStyles<typeof footerStyles> {
    submitFunc: (input: string) => void;
    almeConfig: AlmeFooterConfig;
    isLiveChatConnected?: boolean;
    onSendTypingEvent?: () => void;
    focusProps?: FocusComponentProps;
}

const AlmeFooter: React.FC<AlmeFooterProps> = (props: AlmeFooterProps) => {
    let footerClasses = `${props.classes.root}`;
    if (props.almeConfig.footer.styles.hasBorder) {
        footerClasses += ` ${props.classes.divider}`;
    }
    if (props.almeConfig.footer.styles.hasBackgroundColor) {
        footerClasses += ` ${props.classes.colorBackground}`;
    }

    return (
        <Container disableGutters id='alme-footer-container' className={footerClasses}>
            <>
                <AlmeInput
                    isLiveChatConnected={props.isLiveChatConnected}
                    onSendTypingEvent={props.onSendTypingEvent}
                    almeConfig={props.almeConfig.footer}
                    submitFunc={props.submitFunc}
                    focusProps={props.focusProps}
                    inputId='alme-input-box'
                    submitId='alme-submit-button'
                />
                <AlmeDisclaimer almeConfig={props.almeConfig.footer} focusProps={props.focusProps} />
                <AlmePoweredByLink almeConfig={props.almeConfig.footer} focusProps={props.focusProps} />
            </>
        </Container>
    );
};

export default withStyles(footerStyles)(AlmeFooter);
